<script setup lang="ts">
import Marquee from "shared-ui/components/Marquee.vue";
import customerLogo1 from "@/assets/images/product/customer-logo-1.svg";
import customerLogo2 from "@/assets/images/product/customer-logo-2.avif";
import customerLogo2Srcset from "@/assets/images/product/customer-logo-2.avif?w=64;128;256&format=avif&as=srcset";

type ClientLogo = {
  name: string;
  text?: string;
  src?: string;
  srcset?: string;
  sizes?: string;
  class?: string;
  imgClass?: string;
  width?: number;
  height?: number;
};

const clientLogos: ClientLogo[] = [
  {
    name: "YLSE",
    text: "YLSE",
    class: "font-serif text-[27px] font-bold",
  },
  {
    name: "GOAVA",
    text: "GOAVA",
    class: "text-2xl font-extrabold tracking-wide",
  },
  {
    name: "GOTAIN",
    text: "GOTAIN.",
    class: "font-serif text-[26px] font-bold",
  },
  {
    name: "Sparly",
    text: "Sparly",
    class: "text-[26px] font-bold tracking-tight",
  },
  {
    name: "Oaz",
    src: customerLogo1,
    imgClass: "h-7 w-auto",
    width: 723,
    height: 238,
  },
  {
    name: "NoBiz",
    src: customerLogo2,
    srcset: customerLogo2Srcset,
    sizes: "64px",
    imgClass: "h-6 w-auto",
    width: 1596,
    height: 604,
  },
  {
    name: "Springflod",
    text: "Springflod",
    class: "text-xl font-semibold",
  },
];
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/no-distracting-elements -->
  <Marquee :gap="56" :speed="30" :pause-on-hover="false">
    <li
      v-for="logo in clientLogos"
      :key="logo.name"
      class="flex shrink-0 items-center whitespace-nowrap text-website-logo"
      :class="logo.class"
    >
      <img
        v-if="logo.src"
        :src="logo.src"
        :srcset="logo.srcset"
        :sizes="logo.sizes"
        :alt="logo.name"
        :class="logo.imgClass"
        :width="logo.width"
        :height="logo.height"
      />
      <template v-else>{{ logo.text }}</template>
    </li>
  </Marquee>
</template>
